import HttpClient from '@/utility/http-client';

export default {
    orderList(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/main_order/?filter=${filter}&page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}`;
        return HttpClient.instance().get(url);
    },

    orderById(id: string) {
        const url = `/api/main_order/${id}`;
        return HttpClient.instance().get(url);
    },

    updateOrder(orderById: number, dataRequest: any) {
        const url = `/api/main_order/${orderById}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    updateMultiOrder(dataRequest: any) {
        const url = `/api/main_order/update/`;
        return HttpClient.instance().post(url, dataRequest);
    },

    complainOrder(dataRequest: any) {
        const url = `/api/complain/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    updateComplainOrder(complainId: number, dataRequest: any) {
        const url = `/api/complain/${complainId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    getComplainById(complainId: number) {
        return HttpClient.instance().get(`/api/complain/${complainId}`);
    },

    getBillOfLading(orderId: number, packageType: number = 0) {
        let url = `/api/order_transactions?OrderID=${orderId}`
        url += packageType === 0 ? '' : `&PackageType=${packageType}`;
        return HttpClient.instance().get(url);
    },
    
    createOrder(dataRequest: any) {
        const url = `/api/main_order/new/`;
        return HttpClient.instance().put(url, dataRequest);
    },
};
